import { createSelector } from '@reduxjs/toolkit'
import { RuleType } from '@/models/http'
import { RootState } from '@/store/configureStore'
import { sectorRulesSlice } from '..'

export const hasRuleTypeSelector = createSelector(
  [
    sectorRulesSlice.selectors.rules,
    (_state: RootState, ruleType: RuleType) => ruleType,
  ],
  (rules, ruleType): boolean => {
    if (rules === null) {
      return false
    }

    return Boolean(rules.find((rule) => rule.ruleType === ruleType))
  }
)
